import { createSlice } from '@reduxjs/toolkit';

const screenWidth = window.innerWidth;

const commonSlice = createSlice({
	name: 'common',
	initialState: {
		isMenuOpen: screenWidth >= 1024,
	},
	reducers: {
		setIsMenuOpen(state, action) {
			state.isMenuOpen = action.payload;
		},
	},
});

export const { setIsMenuOpen } = commonSlice.actions;
export default commonSlice.reducer;
